import styled from '@emotion/styled';
import H from '../../typography/Headings';
import {
  Accordion,
  AccordionButton,
  AccordionSection,
  AccordionSectionHeading,
  AccordionV2Container,
  StyledCaret,
} from '../AccordionV2/AccordionV2.styles';
import COLORS from '../../styles/emotion/colors3';
import { FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';
import { StyledImage, CardWrapper } from './PreAuthCarouselCard.styles';

export const Wrapper = styled.div`
  background-color: ${COLORS.MARINE_100};
  border-radius: 16px;
  padding: 80px ${SPACING.LG};
  margin: ${SPACING.S16};

  ${MEDIA_QUERY.DESKTOP_XL} {
    padding: 104px 250px;
  }

  ${MEDIA_QUERY.TABLET} {
    padding: 80px ${SPACING.MD};
  }

  ${MEDIA_QUERY.MOBILE_XS} {
    padding: ${SPACING.S48} ${SPACING.S24};
    margin: ${SPACING.XS};
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${AccordionV2Container} {
    width: 1058px;
    ${MEDIA_QUERY.EXCLUDE_DESKTOP_LG} {
      width: 100%;
    }
  }

  ${Accordion} {
    width: 100%;
  }

  ${AccordionSection}:first-of-type {
    border-top: none !important;
  }

  ${AccordionSection} {
    border-bottom: 1px solid ${COLORS.WHITE_100};
    ${MEDIA_QUERY.TABLET} {
      padding: 0;
    }
    &:hover {
      ${AccordionButton} {
        span {
          color: ${COLORS.WHITE_100};
        }
      }
    }

    ${MEDIA_QUERY.MOBILE_XS} {
      padding: 0;
    }
  }

  ${AccordionSection}:last-of-type {
    border-bottom: none !important;
  }

  ${AccordionButton} {
    padding: ${SPACING.LG} 0;

    ${MEDIA_QUERY.MOBILE} {
      padding: ${SPACING.S24} 0;
    }

    ${MEDIA_QUERY.TABLET} {
      padding: ${SPACING.S32} 0;
    }

    ${AccordionSectionHeading} {
      color: ${COLORS.WHITE_100};
      font-size: ${FONT.FONT_SIZE_LARGER};
      line-height: ${FONT.FONT_SIZE_LARGER};
      font-weight: ${FONT.FONT_WEIGHT_REGULAR};

      ${MEDIA_QUERY.DESKTOP_XL} {
        font-size: ${FONT.FONT_SIZE_SEMI_LARGE};
        line-height: ${FONT.FONT_SIZE_SEMI_LARGE};
      }

      &:hover,
      &:active,
      &:focus {
        color: ${COLORS.WHITE_100};
      }
    }
  }
  ${StyledCaret} {
    color: ${COLORS.WHITE_100};
  }
`;

export const StyledHTitle3 = styled(H.Title3)`
  // Support accordion is always on a blue background, so force the head to always be white
  --text-primary: ${COLORS.WHITE_100};
  margin-bottom: ${SPACING.LG};
  max-width: 480px;
  text-align: center;
  ${MEDIA_QUERY.TABLET} {
    font-size: 42px;
    line-height: 100%;
  }
  ${MEDIA_QUERY.MOBILE} {
    max-width: 320px;
    margin-bottom: ${SPACING.S24};
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: ${SPACING.MD};
  row-gap: ${SPACING.XL};
  align-items: flex-start;
  padding-bottom: ${SPACING.LG};

  button {
    align-self: center;
  }

  ${MEDIA_QUERY.MOBILE} {
    row-gap: ${SPACING.S24};
  }
`;

export const SectionContentWrapper = styled.div`
  display: flex;

  p {
    color: ${COLORS.WHITE_100};
  }

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    flex-direction: column;
  }
`;

export const StyledHr = styled.hr`
  margin: 0 ${SPACING.S24};
  border-left-width: 0;
  opacity: 30%;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    display: none;
  }
`;

export const ButtonWrapper = styled.div`
  align-self: center;
`;

// FAQs

export const FAQSListWrapper = styled.ul`
  column-gap: ${SPACING.MD};
  columns: 2;
  margin-bottom: 60px;
  list-style-type: none;

  ${MEDIA_QUERY.DESKTOP} {
    row-gap: ${SPACING.LG};
  }

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    columns: 1;
  }
  ${MEDIA_QUERY.MOBILE} {
    margin-bottom: ${SPACING.MD};
  }

  > li {
    ${MEDIA_QUERY.DESKTOP} {
      margin-bottom: ${SPACING.LG};
    }

    ${MEDIA_QUERY.MOBILE} {
      margin-bottom: ${SPACING.MD};
    }
  }
`;

// advice

export const AdviceContentWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  list-style-type: none;

  p,
  a {
    color: ${COLORS.WHITE_100};
  }

  ${MEDIA_QUERY.TABLET} {
    column-gap: ${SPACING.S24};
  }

  ${MEDIA_QUERY.MOBILE} {
    flex-direction: column;
  }

  ${CardWrapper} {
    width: 100%;

    ${MEDIA_QUERY.MOBILE} {
      margin-bottom: ${SPACING.S24};

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  ${StyledImage} {
    height: 208px;
  }

  > li {
    ${MEDIA_QUERY.MOBILE} {
      margin-bottom: ${SPACING.MD};
    }
  }
`;

export const InnerList = styled.ul`
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: flex;

  p {
    color: ${COLORS.WHITE_100};
  }

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    flex-direction: column;
  }
`;

export const InnerListItem = styled.li`
  padding: 0;
  margin: 0;
  width: 100%;
`;
